import { onCLS, onINP, onFCP, onLCP, onTTFB, type Metric } from 'web-vitals';

type PerformanceCallback = (metric: Metric) => void;

export function reportWebVitals(onPerfEntry?: PerformanceCallback) {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    onCLS(onPerfEntry);
    onINP(onPerfEntry);
    onFCP(onPerfEntry);
    onLCP(onPerfEntry);
    onTTFB(onPerfEntry);
  }
}

export function logPerformanceMetrics() {
  reportWebVitals((metric) => {
    const { name, value, rating } = metric;
    
    const emoji = rating === 'good' ? '✅' : rating === 'needs-improvement' ? '⚠️' : '❌';
    
    if (window.gtag) {
      window.gtag('event', name, {
        event_category: 'Web Vitals',
        event_label: rating,
        value: Math.round(value),
        non_interaction: true,
      });
    }
  });
}

export function measureRoutePerformance(routeName: string) {
  const startMark = `route-${routeName}-start`;
  const endMark = `route-${routeName}-end`;
  const measureName = `route-${routeName}`;
  
  performance.mark(startMark);
  
  return () => {
    performance.mark(endMark);
    performance.measure(measureName, startMark, endMark);
    
    const measure = performance.getEntriesByName(measureName)[0];
    if (measure) {
    }
    
    performance.clearMarks(startMark);
    performance.clearMarks(endMark);
    performance.clearMeasures(measureName);
  };
}

declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}
